module.exports = __webpack_public_path__ + "static/media/ipg_bkg.276e5ebd.jpg";